import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRowColumn, TableRow } from 'material-ui/Table';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import ChevronLeft from 'material-ui/svg-icons/navigation/chevron-left';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';

import WhiteList from './WhiteList';
import BlackList from './BlackList';
import SelectedUserInfo from './SelectedUserInfo';

import { getUserList, addUsersFromAutocomplete } from 'actions/users';

import api from 'services';

import styles from 'styles';

class TableUsersBan extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            page: 1,
            users: [],
            search: '',
            isDataFromAutoComplete: false,
            selectedUser: undefined,
            selected: [],
        };

        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);

        this.keyPress = this.keyPress.bind(this);
        this.onChange = this.onChange.bind(this);

        this.handleRowSelection = this.handleRowSelection.bind(this);

        this.isSelected = this.isSelected.bind(this);
    }

    isSelected(index) {
        return this.state.selected.indexOf(index) !== -1;
    }

    handleRowSelection(selectedRows) {
        if (selectedRows.length !== 0) {
            this.setState({
                selected: selectedRows,
                selectedUser: this.state.users.find((user, indexUser) => indexUser === selectedRows[0]),
            });
        } else {
            this.setState({
                selectedUser: this.state.selectedUser,
            });
        }
    }

    onChange(e, value) {
        this.setState({
            search: value,
        }, () => {
            if (this.state.search === '') {
                this.props.getUserList({
                    page: 1,
                });

                this.setState({
                    selected: [],
                    selectedUser: undefined,
                });
            }
        });
    }

    keyPress(e) {
        if (e.keyCode === 13) {
            if (this.state.search === '') {
                return
            }

            api.findUser(this.state.search, true)
                .then((response) => {
                    this.setState({
                        selected: [],
                        selectedUser: undefined,
                    }, () => {
                        this.props.addUsersFromAutocomplete(response.data);
                    });
                })
                .catch((response) => {
                    console.error(response);
                })
        }
    }

    nextPage() {
        this.setState({
            selected: [],
            selectedUser: undefined,
        }, () => {
            this.props.getUserList({
                page: this.state.next,
                limit: 25,
            });
        });
    }

    prevPage() {
        this.setState({
            selected: [],
            selectedUser: undefined,
        }, () => {
            this.props.getUserList({
                page: this.state.previous,
                limit: 25,
            });
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            users: nextProps.users.data,
            page: nextProps.users.page || 1,
            previous: nextProps.users.previous,
            next: nextProps.users.next,
            isDataFromAutoComplete: nextProps.users.isDataFromAutoComplete,
        });
    }

    render() {
        const { users, page, isDataFromAutoComplete, selectedUser } = this.state;

        return (
            <div>
                <div className='row'>
                    <div className='col-xs-4 middle-xs' style={{ display: 'flex' }}>
                        <div style={{ width: '100%' }}>
                            <TextField
                                floatingLabelText='Search (min 3 symbols, then push enter)'
                                onChange={this.onChange}
                                onKeyDown={this.keyPress}
                                fullWidth
                            />
                        </div>
                    </div>

                    <div className='col-xs-2'>

                    </div>

                    <div className='col-xs-6'>
                        <div className=' center-xs middle-xs' style={{ width: '100%', display: 'flex' }}>
                            {
                                !isDataFromAutoComplete
                                    ?
                                    <Fragment>
                                        <IconButton
                                            iconStyle={styles.navigationLeft}
                                            name='navigationLeft'
                                            onClick={this.prevPage}
                                        >
                                            <ChevronLeft />
                                        </IconButton>
                                        <span>Page: {page}</span>
                                        <IconButton
                                            iconStyle={styles.navigationRight}
                                            name='navigationRight'
                                            onClick={this.nextPage}
                                        >
                                            <ChevronRight />
                                        </IconButton>
                                    </Fragment>
                                    : null
                            }
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-9">
                        <div className="paper-block">
                            <div className='table-body'>
                                <Table onRowSelection={this.handleRowSelection}>
                                    <TableHeader displaySelectAll={false}>
                                        <TableRow>
                                            <TableHeaderColumn>
                                                Name
                                            </TableHeaderColumn>
                                            <TableHeaderColumn>
                                                Email
                                            </TableHeaderColumn>
                                            <TableHeaderColumn>
                                                Company name
                                            </TableHeaderColumn>
                                        </TableRow>
                                    </TableHeader>

                                    <TableBody>
                                        {
                                            users.map((user, indexUser) => {
                                                return (<TableRow selected={this.isSelected(indexUser)} key={user._id}>
                                                    <TableRowColumn>
                                                        {
                                                            user.name
                                                        }
                                                    </TableRowColumn>
                                                    <TableRowColumn>
                                                        {
                                                            user.email
                                                        }
                                                    </TableRowColumn>
                                                    <TableRowColumn>
                                                        {
                                                            user.company && user.company.name
                                                        }
                                                    </TableRowColumn>
                                                </TableRow>);
                                            })
                                        }
                                    </TableBody>
                                </Table>
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-3">
                        <SelectedUserInfo
                            selectedUser={selectedUser}
                        />
                        <WhiteList
                            selectedUser={selectedUser}
                        />
                        <BlackList
                            selectedUser={selectedUser}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ users, userLimitations }) => {
        return {
            users,
            userLimitations,
        };
    },
    dispatch => bindActionCreators({
            getUserList,
            addUsersFromAutocomplete,
        },
        dispatch),
)(TableUsersBan);



// WEBPACK FOOTER //
// ./app/components/Users/BlackAndWhiteLists/Table.jsx